"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnWidth = void 0;
const constants_1 = require("./constants");
const getColumnWidth = ({ width, minWidth }) => {
    return Math.max(width !== null && width !== void 0 ? width : 0, minWidth !== null && minWidth !== void 0 ? minWidth : constants_1.MIN_COLUMN_WIDTH, 0);
};
exports.getColumnWidth = getColumnWidth;
//# sourceMappingURL=getColumnWidth.js.map